const HistoryLogEntityType = {
    ITEM: 'ITEM',
    CAMPAIGN: 'CAMPAIGN'
};

module.exports = Object.freeze(HistoryLogEntityType);